/* eslint-disable no-nested-ternary */
import React from 'react';
import { Typography, Box } from '@material-ui/core';
import ICWVerifiedIcon from 'assets/icons/icw-check-icon.svg';
import { Clear as ClearIcon } from '@material-ui/icons';
import { Tooltip } from 'components';
import moment from 'moment';
import classes from './VerifyTooltip.module.scss';

const VerifyTooltip = ({ verifyNotes, verifiedBy, verifiedStatus, notes, verifiedAt }) => {
  const statusText =
    verifiedStatus === 'notApplicable'
      ? 'Reviewed'
      : verifiedStatus === 'accepted'
      ? 'Accepted'
      : 'Rejected';
  return (
    <Tooltip
      placement='top'
      title={
        <Box className={classes.content}>
          <Typography className={classes.title}>
            {statusText} By {verifiedBy} {verifyNotes}
          </Typography>
          <Typography className={classes.description}>{notes}</Typography>
          <Typography variant='caption' className={classes.caption}>
            {verifiedAt ? moment(verifiedAt).format('DD/MM/YYYY,  HH:mm') : ''}
          </Typography>
        </Box>
      }
      arrow>
      {verifiedStatus === 'notApplicable' ? (
        <Typography className={classes.notApplicable}>N/A</Typography>
      ) : verifiedStatus === 'accepted' ? (
        <img src={ICWVerifiedIcon} alt='icw-verified' />
      ) : (
        <div className={classes.warningIcon}>
          <ClearIcon />
        </div>
      )}
    </Tooltip>
  );
};

export default VerifyTooltip;
